import { render, staticRenderFns } from "./DokaOverlay.vue?vue&type=template&id=b1f1a7ec&"
import script from "./DokaOverlay.vue?vue&type=script&lang=js&"
export * from "./DokaOverlay.vue?vue&type=script&lang=js&"
import style0 from "./DokaOverlay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports